import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateInitiative = createAsyncThunk(
  "initiatives/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (!response.data?.success) {
        return rejectWithValue(response.data?.message || "Failed to update initiative");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update initiative");
    }
  }
);
